<div class="modal-header">
  <button type="button" class="close" aria-label="{{'Close'|translate}}" [mat-dialog-close]="true">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center f-s-18" >
  <cms [title]="data.title" (cmsFoundChange)="cmsFoundChange($event)"></cms>
  @if (isLoadingCms) {
    <contentloader></contentloader>
  }
</div>


